__turbopack_context__.v({
  "fundraisercontainer": "Fundraisers-module__3iuura__fundraisercontainer",
  "fundraiserdata": "Fundraisers-module__3iuura__fundraiserdata",
  "fundraiserdescription": "Fundraisers-module__3iuura__fundraiserdescription",
  "mobiletitle": "Fundraisers-module__3iuura__mobiletitle",
});
